import { z } from "zod";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

// Coarse IP-derived country/state, opt-in per form, disclosed in the privacy notice
// (docs/01-PRODUCT-SPEC.md §3.2). Coarse on purpose — this is personal data under NDPA.
const configSchema = z.object({});

export const geoCaptureField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "geo_capture",
  label: "Approximate location",
  category: "system",
  icon: "Globe",
  configSchema,
  valueSchema: (_config, isRequired) =>
    optionalUnlessRequired(
      z
        .object({ country: z.string().max(100).optional(), state: z.string().max(100).optional() })
        .strict(),
      isRequired,
    ),
  defaultConfig: {},
  supportsProfileBinding: false,
  defaultSearchable: false,
  renderHints: { isHiddenFromApplicant: true },
};
